/**
 * @generated SignedSource<<1813c0f7475486d3f849d4c0fbc9d6f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NotionSendNotesModalMutation$variables = {
  icon?: string | null;
  includeMeetingRecap?: boolean | null;
  isDatabase: boolean;
  noteId: string;
  notionPageId: string;
  title?: string | null;
};
export type NotionSendNotesModalMutation$data = {
  readonly sendNoteToNotion: {
    readonly asyncResultId: any | null;
  } | null;
};
export type NotionSendNotesModalMutation = {
  response: NotionSendNotesModalMutation$data;
  variables: NotionSendNotesModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "icon"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeMeetingRecap"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDatabase"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "notionPageId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "icon",
        "variableName": "icon"
      },
      {
        "kind": "Variable",
        "name": "includeMeetingRecap",
        "variableName": "includeMeetingRecap"
      },
      {
        "kind": "Variable",
        "name": "isDatabase",
        "variableName": "isDatabase"
      },
      {
        "kind": "Variable",
        "name": "noteId",
        "variableName": "noteId"
      },
      {
        "kind": "Variable",
        "name": "notionPageId",
        "variableName": "notionPageId"
      },
      {
        "kind": "Variable",
        "name": "title",
        "variableName": "title"
      }
    ],
    "concreteType": "SendNoteToNotion",
    "kind": "LinkedField",
    "name": "sendNoteToNotion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "asyncResultId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotionSendNotesModalMutation",
    "selections": (v6/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "NotionSendNotesModalMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "93b40726a2f5fb79685fa9d804b4e18a",
    "id": null,
    "metadata": {},
    "name": "NotionSendNotesModalMutation",
    "operationKind": "mutation",
    "text": "mutation NotionSendNotesModalMutation(\n  $title: String\n  $noteId: ID!\n  $notionPageId: String!\n  $isDatabase: Boolean!\n  $icon: String\n  $includeMeetingRecap: Boolean\n) {\n  sendNoteToNotion(title: $title, noteId: $noteId, notionPageId: $notionPageId, isDatabase: $isDatabase, icon: $icon, includeMeetingRecap: $includeMeetingRecap) {\n    asyncResultId\n  }\n}\n"
  }
};
})();

(node as any).hash = "dd217f2afd5848f3a3c3a67608acbeeb";

export default node;
